import React from "react";
import Navbar from "../Components/Navbar";
import '../Styles/AboutGetInvolved.scss';
import GetInvolvedPage1 from "../Components/GetInvolvedPage1";
import GetInvolvedPage2 from "../Components/GetInvolvedPage2";
import GetInvolvedPage3 from "../Components/GetInvolvedPage3";
import Footer from "../Components/Footer.js";
import {Helmet} from "react-helmet";

function AboutGetInvolved() {
   return (
      <div>
         <Helmet>
            <title>Get Involved - Camp Connect</title>
         </Helmet>
         <div className="getInvolvedNav">
            <Navbar/>
         </div>
         <GetInvolvedPage1/>
         <GetInvolvedPage2/>
         <GetInvolvedPage3/>
         <Footer/>
      </div>
   )
};

export default AboutGetInvolved;
